import { useMemo } from "react";


export const getIsMultiSearch = ({ icp }: { icp: any }) => {
    return icp?.child_icps && icp.child_icps.length > 0;
}

const useIsMultiSearch = ({ icp } : { icp: any }) => {
    
    return useMemo(() => getIsMultiSearch({ icp }), [icp]);
};

export default useIsMultiSearch;